import type { OverdueSection } from "./dayPanel";

/**
 * Last-known items:overdueWindow responses, per viewer (ticket #272).
 * The today ring reads this seam so a fresh mount serves the viewer's
 * last-known response while the live query settles, instead of reading
 * "no overdue" — a today ringed only by overdue items must never
 * regress to a bare disc after it has been ringed this session.
 *
 * Boundaries: an unknown viewer (the users:me read still settling)
 * passes the live value through and touches nothing — unknown never
 * paints from a cache (the #207 safe-default posture). A settled null
 * (the signed-out answer) is the server's own word: it passes through,
 * is never remembered, and never clobbers the last-known. The
 * first-ever mount of a session has no last-known data and still
 * settles in, same as the grid's own #213 settle-in. A call carrying
 * a settled response also remembers it — query and write ride one
 * call — and that remembered response is stale only until the live
 * query lands and replaces it (across a UTC-midnight rollover the
 * beat can serve rows fetched under the previous day's window; the
 * live query corrects them).
 */
const lastKnown = new Map<string, OverdueSection>();

export function lastKnownOverdue(
  viewerKey: string | undefined,
  live: OverdueSection | null | undefined,
): OverdueSection | null | undefined {
  if (viewerKey === undefined) return live;
  if (live !== undefined && live !== null) lastKnown.set(viewerKey, live);
  return live !== undefined ? live : lastKnown.get(viewerKey);
}
